import React, { useEffect, useState } from "react";
import { adminGetAllCabs } from "../services/Api";
import { useLocation, useNavigate } from "react-router-dom";
import { Image } from "antd";

const CabDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const cabId = location.state?.cabId;
    const [cabDetailsData, setCabDetailsData] = useState({});

    const handleGetAllCabs = () => {
        adminGetAllCabs(null, null, null, null, null, null, null, null, cabId)
            .then((res) => {
                console.log(res?.data?.data);
                setCabDetailsData(res?.data?.data[0])
            })
            .catch((err) => {
            })
    }

    useEffect(() => {
        handleGetAllCabs()
    }, [cabId]);

    if (!cabDetailsData) {
        return (
            <div className="p-8 text-center text-gray-500">
                No cab data available.
            </div>
        );
    }


    return (
        <div className="p-8 shadow-lg rounded-2xl max-w-6xl mx-auto my-10 bg-gray-100">
            <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500" onClick={() => navigate(-1)}>
                <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
                </svg>
                <span className=" text-white ms-1">Back</span>
            </button>
            <h1 className="text-3xl font-bold text-[#E53935] mb-6 text-center">
                Cab Details
            </h1>

            {/* Basic Details */}
            <div className="grid grid-cols-2 gap-4 text-gray-700">
                <div>
                    <p className="font-semibold">Cab Number:</p>
                    <p>{cabDetailsData?.cab_number || "N/A"}</p>
                </div>
                <div>
                    <p className="font-semibold">Vehicle Type:</p>
                    <p>{cabDetailsData?.vehicleType?.vehicleType || "N/A"}</p>
                </div>
                <div>
                    <p className="font-semibold">Vehicle Category:</p>
                    <p>{cabDetailsData?.vehicleType?.category || "N/A"}</p>
                </div>
                <div>
                    <p className="font-semibold">Has Carrier:</p>
                    <p>{cabDetailsData?.has_carrier ? "Yes" : "No"}</p>
                </div>
            </div>

            {/* User Details */}
            {cabDetailsData?.user_info && (
                <div className="mt-6">
                    <h2 className="text-xl font-semibold text-[#E53935] mb-3">
                        User Info
                    </h2>
                    <div className="grid grid-cols-2 gap-4 text-gray-700">
                        <div>
                            <p className="font-semibold">User Name:</p>
                            <p>{cabDetailsData?.user_info.name || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Email:</p>
                            <p>{cabDetailsData?.user_info.email || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Phone Number:</p>
                            <p>{cabDetailsData?.user_info.phoneNumber || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Aadhar Number:</p>
                            <p>{cabDetailsData?.user_info.aadhar_number || "N/A"}</p>
                        </div>
                    </div>
                </div>
            )}
            {/* Additional Details */}
            {cabDetailsData?.additional_details && (
                <div className="mt-6">
                    <h2 className="text-xl font-semibold text-[#E53935] mb-3">
                        Vehicle Info
                    </h2>
                    <div className="grid grid-cols-2 gap-4 text-gray-700">
                        <div>
                            <p className="font-semibold">Owner Name:</p>
                            <p>{cabDetailsData?.additional_details.owner_name || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">RC Number:</p>
                            <p>{cabDetailsData?.additional_details.rc_number || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Fuel Type:</p>
                            <p>{cabDetailsData?.additional_details.fuel_type || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Maker:</p>
                            <p>{cabDetailsData?.additional_details.maker_description || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Model:</p>
                            <p>{cabDetailsData?.additional_details.maker_model || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Registration Date:</p>
                            <p>{cabDetailsData?.additional_details.registration_date || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Registered At:</p>
                            <p>{cabDetailsData?.additional_details.registered_at || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Fit Upto:</p>
                            <p>{cabDetailsData?.additional_details.fit_up_to || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Tax Upto:</p>
                            <p>{cabDetailsData?.additional_details.tax_upto || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Insurance Upto:</p>
                            <p>{cabDetailsData?.additional_details.insurance_upto || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-semibold">Permit Upto:</p>
                            <p>{cabDetailsData?.additional_details.permit_valid_upto || "N/A"}</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Certificate Details */}

            {cabDetailsData?.expiry_alerts && (
                <div className="mt-6">
                    <h2 className="text-xl font-semibold text-[#E53935] mb-3">
                        Certificate Details
                    </h2>
                    <div className="grid grid-cols-2 gap-4 text-gray-700">
                        <div className="flex gap-10 items-center">
                            <p className="font-semibold">Fitness Upto:</p>
                            {(cabDetailsData?.expiry_alerts?.fitness_certificate?.is_expiring_soon ||
                                cabDetailsData?.expiry_alerts?.fitness_certificate?.is_expired) ? (
                                <div className="flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="red"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 
          1.948 3.374h14.71c1.73 0 2.813-1.874 
          1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 
          0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        />
                                    </svg>
                                    <p className="text-sm font-semibold text-red-600 ms-1">
                                        {cabDetailsData?.expiry_alerts?.fitness_certificate?.is_expired
                                            ? "Expired"
                                            : `Expiring Soon (${cabDetailsData?.expiry_alerts?.fitness_certificate?.days_left} days)`}
                                    </p>
                                </div>
                            ) : (
                                <p className="text-sm font-semibold text-green-600">
                                    Valid till {cabDetailsData?.expiry_alerts?.fitness_certificate?.date}
                                </p>
                            )}
                        </div>
                        <div className="flex gap-10 items-center">
                            <p className="font-semibold">Tax Upto:</p>
                            {(cabDetailsData?.expiry_alerts?.tax_certificate?.is_expiring_soon ||
                                cabDetailsData?.expiry_alerts?.tax_certificate?.is_expired) ? (
                                <div className="flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="red"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 
          1.948 3.374h14.71c1.73 0 2.813-1.874 
          1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 
          0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        />
                                    </svg>
                                    <p className="text-sm font-semibold text-red-600 ms-1">
                                        {cabDetailsData?.expiry_alerts?.tax_certificate?.is_expired
                                            ? "Expired"
                                            : `Expiring Soon (${cabDetailsData?.expiry_alerts?.tax_certificate?.days_left} days)`}
                                    </p>
                                </div>
                            ) : (
                                <p className="text-sm font-semibold text-green-600">
                                    Valid till {cabDetailsData?.expiry_alerts?.tax_certificate?.date}
                                </p>
                            )}
                        </div>
                        <div className="flex gap-10 items-center">
                            <p className="font-semibold">Insurance Upto:</p>
                            {(cabDetailsData?.expiry_alerts?.insurance?.is_expiring_soon ||
                                cabDetailsData?.expiry_alerts?.insurance?.is_expired) ? (
                                <div className="flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="red"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 
          1.948 3.374h14.71c1.73 0 2.813-1.874 
          1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 
          0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        />
                                    </svg>
                                    <p className="text-sm font-semibold text-red-600 ms-1">
                                        {cabDetailsData?.expiry_alerts?.insurance?.is_expired
                                            ? "Expired"
                                            : `Expiring Soon (${cabDetailsData?.expiry_alerts?.insurance?.days_left} days)`}
                                    </p>
                                </div>
                            ) : (
                                <p className="text-sm font-semibold text-green-600">
                                    Valid till {cabDetailsData?.expiry_alerts?.insurance?.date}
                                </p>
                            )}
                        </div>
                        <div className="flex gap-10 items-center">
                            <p className="font-semibold">Permit Upto:</p>
                            {(cabDetailsData?.expiry_alerts?.permit?.is_expiring_soon ||
                                cabDetailsData?.expiry_alerts?.permit?.is_expired) ? (
                                <div className="flex">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="red"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 
          1.948 3.374h14.71c1.73 0 2.813-1.874 
          1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 
          0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                        />
                                    </svg>
                                    <p className="text-sm font-semibold text-red-600 ms-1">
                                        {cabDetailsData?.expiry_alerts?.permit?.is_expired
                                            ? "Expired"
                                            : `Expiring Soon (${cabDetailsData?.expiry_alerts?.permit?.days_left} days)`}
                                    </p>
                                </div>
                            ) : cabDetailsData?.expiry_alerts?.permit?.date ? (
                                <p className="text-sm font-semibold text-green-600">
                                    Valid till {cabDetailsData?.expiry_alerts?.permit?.date}
                                </p>
                            ) : (
                                <p className="text-sm text-gray-500">No record</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Vehicle Images */}
            <div className="mt-8">
                <h2 className="text-xl font-semibold text-[#E53935] mb-3">
                    Vehicle Images
                </h2>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 h-40">
                    {(!cabDetailsData?.vehicle_img || cabDetailsData?.vehicle_img === 'null' || cabDetailsData?.vehicle_img === null) ? ("") : (
                        <Image
                            src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.vehicle_img}`}
                            alt={`Vehicle 1`}
                            width={200}
                            height={200}
                            className="rounded-lg border shadow-sm"
                        />
                    )}
                    {(!cabDetailsData?.vehicle_img1 || cabDetailsData?.vehicle_img1 === 'null' || cabDetailsData?.vehicle_img1 === null) ? ("") : (
                        <Image
                            src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.vehicle_img1}`}
                            alt={`Vehicle 2`}
                            width={200}
                            height={200}
                            className="rounded-lg border shadow-sm"
                        />
                    )}
                    {(!cabDetailsData?.vehicle_img2 || cabDetailsData?.vehicle_img2 === 'null' || cabDetailsData?.vehicle_img2 === null) ? ("") : (
                        <Image
                            src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.vehicle_img2}`}
                            alt={`Vehicle 3`}
                            width={200}
                            height={200}
                            className="rounded-lg border shadow-sm"
                        />
                    )}
                    {(!cabDetailsData?.vehicle_img3 || cabDetailsData?.vehicle_img3 === 'null' || cabDetailsData?.vehicle_img3 === null) ? ("") : (
                        <Image
                            src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.vehicle_img3}`}
                            alt={`Vehicle 4`}
                            width={200}
                            height={200}
                            className="rounded-lg border shadow-sm"
                        />
                    )}
                </div>
            </div>

            {/* Document Status */}
            <div className="mt-20">
                <h2 className="text-xl font-semibold text-[#E53935] mb-3">
                    Document Status
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-6 gap-4 text-gray-700 h-48">
                    {(!cabDetailsData?.document_images?.rc_image || cabDetailsData?.document_images?.rc_image === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">RC Image:</p>
                            <p className={`${cabDetailsData?.document_status?.rc_image_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.rc_image_approved ? "Approved" : "Not Approved "}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.rc_image}`}
                                alt="RC Image"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                    {(!cabDetailsData?.document_images?.cab_number_plate || cabDetailsData?.document_images?.cab_number_plate === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">Number Plate:</p>
                            <p className={`${cabDetailsData?.document_status?.cab_number_plate_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.cab_number_plate_approved
                                    ? "Approved"
                                    : "Not Approved"}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.cab_number_plate}`}
                                alt="Number Plate"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                    {(!cabDetailsData?.document_images?.insurance || cabDetailsData?.document_images?.insurance === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">Insurance:</p>
                            <p className={`${cabDetailsData?.document_status?.insurance_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.insurance_approved
                                    ? "Approved"
                                    : "Not Approved"}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.insurance}`}
                                alt="Insurance"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                    {(!cabDetailsData?.document_images?.permit_certificate || cabDetailsData?.document_images?.permit_certificate === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">Permit Certificate:</p>
                            <p className={`${cabDetailsData?.document_status?.permit_certificate_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.permit_certificate_approved
                                    ? "Approved"
                                    : "Not Approved"}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.permit_certificate}`}
                                alt="Permit Certificate"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                    {(!cabDetailsData?.document_images?.puc_certificate || cabDetailsData?.document_images?.puc_certificate === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">PUC Certificate:</p>
                            <p className={`${cabDetailsData?.document_status?.puc_certificate_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.puc_certificate_approved
                                    ? "Approved"
                                    : "Not Approved"}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.puc_certificate}`}
                                alt="PUC Certificate"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                    {(!cabDetailsData?.document_images?.fitness_certificate || cabDetailsData?.document_images?.fitness_certificate === 'null') ? ("") : (
                        <div>
                            <p className="font-semibold">Fitness Certificate:</p>
                            <p className={`${cabDetailsData?.document_status?.fitness_certificate_approved ? "text-green-500" : "text-red-500"}`}>
                                {cabDetailsData?.document_status?.fitness_certificate_approved
                                    ? "Approved"
                                    : "Not Approved"}
                            </p>
                            <Image
                                src={`${process.env.REACT_APP_API_URL}${cabDetailsData?.document_images?.fitness_certificate}`}
                                alt="Fitness Certificate"
                                width={150}
                                height={150}
                                className="rounded-lg border shadow-sm"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default CabDetails;
